<template>
  <div>
    <div
      v-if="hasRole('ROLE_SALES_MANAGER') || hasRole('ROLE_BUSINESS_ADMIN')"
      class="level is-mobile"
    >
      <div class="level-left" />
      <div class="level-right">
        <div class="level-item">
          <b-field class="is-light">
            <b-select
              v-model="selected"
              placeholder="FILTER BY"
              size="is-small"
            >
              <option value="all">
                All
              </option>

              <hr class="dropdown-divider">

              <option value="self">
                Self
              </option>

              <hr class="dropdown-divider">

              <option
                v-for="(subordinate, subordinateIndex) in subordinatesList"
                :key="subordinateIndex"
                :value="subordinate.id"
              >
                {{ subordinate.fullname.trim() }}
              </option>

              <hr class="dropdown-divider">

              <option
                v-for="team in teams"
                :key="team.id"
                :value="`team${team.id}`"
              >
                {{ team.name }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>

    <div class="card is-rounded-card is-spaced-top">
      <header class="card-header">
        <p class="card-header-title">
          open leads by status
        </p>
      </header>

      <div class="card-content">
        <highcharts
          v-if="hasData"
          :options="leadsByStageSeries"
        />

        <div
          v-else
          class="level is-mobile"
        >
          <div class="level-item has-text-centered">
            <div>
              <figure class="image">
                <img
                  src="@/assets/images/no-data.svg"
                  alt="No Data"
                >
              </figure>
              <b-button
                type="is-primary"
                size="is-small"
              >
                no data found
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Chart } from 'highcharts-vue';

export default {
  name: 'OpenLeadsByStage',

  components: {
    highcharts: Chart,
  },

  data: () => ({
    self: localStorage.getItem('user_id'),
    selected: '',
  }),

  computed: {
    ...mapGetters({
      leadsByStage: 'Graphs/getLeadsByStage',
      subordinatesList: 'Users/getSubordinates',
      teams: 'Graphs/getTeams',
    }),

    hasData() {
      const data = [...this.leadsByStage];
      const totalArray = data.map((el) => el.Total);
      const total = totalArray.reduce((a, b) => a + b, 0);
      return data.length > 0 && total > 0;
    },

    leadsByStageSeries() {
      const data = [...this.leadsByStage];

      const series = data.map((el) => ({
        name: el.Name.replace('Qualifed', 'Contacted'),
        y: el.Total,
      }));

      const openDrilldown = (stagename) => {
        const selectedSubordinate = this.subordinatesList.find(
          (subordinate) => subordinate.id === this.selected,
        );
        if (selectedSubordinate) {
          this.$emit('open-drilldown', {
            name: 'leads',
            filters: {
              status: stagename.toString()
                .includes('Not') ? 'Open - Not' : 'Open - Qual',
              owners: this.selected === 'self'
                ? localStorage.getItem('full_name') : selectedSubordinate.fullname,
            },
          });
        } else if (this.selected.toString().startsWith('team')) {
          this.$emit('open-drilldown', {
            name: 'leads',
            filters: {
              status: stagename.toString()
                .includes('Not') ? 'Open - Not' : 'Open - Qual',
              teamId: this.selected.toString().substring(4),
            },
          });
        } else {
          this.$emit('open-drilldown', {
            name: 'leads',
            filters: {
              status: stagename.toString()
                .includes('Not') ? 'Open - Not' : 'Open - Qual',
            },
          });
        }
      };

      return {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
          style: {
            fontFamily: 'Open Sans',
          },
        },

        credits: {
          enabled: false,
        },

        title: {
          text: null,
        },

        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false,
            },
            showInLegend: true,
          },

          series: {
            allowPointSelect: true,
            point: {
              events: {
                select(event) {
                  openDrilldown(event.target.name);
                },
              },
            },
          },
        },

        colors: ['#A3CC39', '#78539D', '#3B90D3', '#FF6600'],

        series: [
          {
            name: 'status',
            colorByPoint: true,
            data: series,
          },
        ],

        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                'printChart',
                'separator',
                'downloadPNG',
                'downloadJPEG',
                'downloadPDF',
                'downloadSVG',
              ],
            },
          },
        },
      };
    },
  },

  watch: {
    selected: {
      handler(value) {
        if (value === 'all') {
          this.$store.dispatch('Graphs/fetchLeadsByStage', { teamid: '', userid: '' });
        } else if (value === 'self') {
          this.$store.dispatch('Graphs/fetchLeadsByStage', { teamid: '', userid: this.self });
        } else if (value.toString().startsWith('team')) {
          this.$store.dispatch('Graphs/fetchLeadsByStage', { teamid: value.toString().substring(4), userid: '' });
        } else {
          this.$store.dispatch('Graphs/fetchLeadsByStage', { teamid: '', userid: value });
        }
      },

      deep: true,
    },
  },

  async created() {
    try {
      if (this.hasRole('ROLE_SALES_PERSON')) {
        await this.$store.dispatch('Graphs/fetchLeadsByStage', { teamid: '', userid: this.self });
      } else {
        await this.$store.dispatch('Graphs/fetchLeadsByStage', { teamid: '', userid: '' });
      }

      this.selected = this.hasRole('ROLE_SALES_PERSON') ? 'self' : 'all';
    } catch (error) {
      console.error(error);
    }
  },

};
</script>

<style>

</style>
